import { Product } from 'depoto-core'
import { PhotoSwipe } from '../../../components/PhotoSwipe'
import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFile } from '@fortawesome/pro-regular-svg-icons'
import { faFragile, faExpandAlt, faTurnDownRight } from '@fortawesome/pro-solid-svg-icons'
import { Tag } from '../../../components/Tag'
import { FragmentType, graphql, useFragment } from '../../../gql'

export const ProductCell_ProductFragment = graphql(`
  fragment ProductCell_ProductFragment on Product {
    id
    fullName
    code
    ean
    name
    mainImage {
      thumbnails {
        format
        url
      }
    }
    files {
      id
    }
    tags {
      id
      ...TagComponent_TagFragment
    }
    isFragile
    isOversize
  }
`)

export function ProductCell(props: {
  product?: FragmentType<typeof ProductCell_ProductFragment>
  isBundleChild?: boolean
}) {
  const product = useFragment(ProductCell_ProductFragment, props.product)

  const thumbUrl = product?.mainImage?.thumbnails?.length
    ? product?.mainImage.thumbnails.filter(t => t.format === 'w135')[0].url
    : ''

  const imageUrl = product?.mainImage?.thumbnails?.length
    ? product?.mainImage.thumbnails.filter(t => t.format === 'w2048')[0].url
    : ''

  return (
    <div className="flex flex-row gap-2 items-center">
      {props.isBundleChild && (
        <div className="pl-3">
          <FontAwesomeIcon icon={faTurnDownRight} size="lg" className={'mr-2'} />
        </div>
      )}
      <PhotoSwipe
        alt={''}
        caption={`
                        ${product?.name || product?.fullName ? product?.name || product?.fullName : ''} <br> 
                        ${product?.code ? 'Kód: ' + product?.code : ''} <br> 
                        ${product?.ean ? 'EAN: ' + product?.ean : ''}`}
        galleryImg={imageUrl}
        src={thumbUrl}
        thumbnails={''}
      />
      <div className={'font-semibold'}>{product?.name || product?.fullName}</div>
      <div className="flex flex-row flex-wrap items-center gap-2">
        {(product?.tags || []).map(tag => (
          <div key={tag.id}>
            <Tag tag={tag} />
          </div>
        ))}
        {product?.isFragile && (
          <div>
            <span className={'label-yellow'}>
              <FontAwesomeIcon icon={faFragile} size="lg" className={'mr-2'} />
              <span>Křehké</span>
            </span>
          </div>
        )}
        {product?.isOversize && (
          <div>
            <span className={'label-purple'}>
              <FontAwesomeIcon icon={faExpandAlt} size="lg" className={'mr-2'} />
              <span>Nadměrné</span>
            </span>
          </div>
        )}
      </div>
    </div>
  )
}
